
import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

interface FeatureCardProps {
  feature: {
    title: string;
    description: string;
    icon: React.ReactNode;
    color: string;
    delay: number;
    link: string;
  };
  isHovered: boolean;
  onHover: (isHovered: boolean) => void;
}

const FeatureCard: React.FC<FeatureCardProps> = ({ feature, isHovered, onHover }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: feature.delay + 0.7, duration: 0.5 }}
      onMouseEnter={() => onHover(true)}
      onMouseLeave={() => onHover(false)}
    >
      <Link to={feature.link}>
        <Card className="overflow-hidden h-full border-none shadow-lg">
          <CardContent className="p-0">
            <div className={`h-full bg-gradient-to-r ${feature.color} p-6 relative transition-all duration-300`}>
              <motion.div 
                className="p-3 bg-white/20 rounded-full w-min mb-4"
                whileHover={{ rotate: 15 }}
              >
                {feature.icon}
              </motion.div>
              <h3 className="text-xl font-display font-semibold text-white mb-2">
                {feature.title}
              </h3>
              <p className="text-white/80 mb-6">
                {feature.description}
              </p>
              
              <motion.div
                animate={{
                  y: isHovered ? -5 : 0,
                  opacity: isHovered ? 1 : 0.7,
                }}
                transition={{ duration: 0.2 }}
              >
                <Button className="bg-white hover:bg-white/90 text-gray-800">
                  Explore &rarr;
                </Button>
              </motion.div>
              
              {/* Decorative elements */}
              <div className="absolute -bottom-4 -right-4 w-20 h-20 bg-white/10 rounded-full" />
              <div className="absolute top-4 right-4 w-10 h-10 bg-white/10 rounded-full" />
            </div>
          </CardContent>
        </Card>
      </Link>
    </motion.div>
  );
};

export default FeatureCard;
